/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from '../client/http-client';
import {
  type AccessTokenResponseDto,
  type AuthWithClassicResponseDto,
  type BankAccountResponseDto,
  type CreditCardDto,
  type CursorPaginationResponseDtoNftResponseDto,
  type CursorPaginationResponseDtoUserNftHistoryResponseDto,
  type CursorPaginationResponseDtoUserOwnCollectionsResponseDto,
  type CursorPaginationResponseDtoUserResponseDto,
  type CursorPaginationResponseDtoUserSettlementHistoryResponseDto,
  type DevAptosCreateResponseDto,
  type DevUserAptosWalletCreateRequestDto,
  type ErrorResponseDto,
  type LinkedUserResponseDto,
  type OAuthRequestDto,
  type OffsetPaginationResponseDtoLinkedUserResponseDto,
  type SavedCardDto,
  type SiteRoleRequestDto,
  type SuccessCountResponseDto,
  type SuccessIdResponseDto,
  type UserAddAdminPartnerRequestDto,
  type UserAddMetaMaskRequestDto,
  type UserAddUserPartnerRequestDto,
  type UserAergoBlockChainWalletResponseDto,
  type UserAptosBlockChainWalletResponseDto,
  type UserAvalancheBlockChainWalletResponseDto,
  type UserBankAccountRequestDto,
  type UserEthereumBlockChainWalletResponseDto,
  type UserMetaMaskResponseDto,
  type UserPolygonBlockChainWalletResponseDto,
  type UserPrivacyResponseDto,
  type UserResponseDto,
  type UserSignUpRequestDtoForTest,
  type UserUpdateMetaMaskRequestDto,
  type UserUpdateRequestDto,
  type VerificationRequestDto,
  type VerifyUserPhoneRequestDto,
  type WalletRequestDto,
} from '../dto/data-contracts';

export class User<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Stripe에 카드 정보 등록 및 DB에 카드 정보 아이디 등록
   *
   * @tags User
   * @name RegisterCardToCustomer
   * @summary 카드 정보 등록
   * @request POST:/v1/user-actions/card/register
   * @secure
   */
  registerCardToCustomer = (data: CreditCardDto, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/user-actions/card/register`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 특정 필드에 대한 조건으로 userId 조회
   *
   * @tags User
   * @name GetUserByUrl
   * @summary 유저 조회
   * @request GET:/v1/user-actions/find
   */
  getUserByUrl = (
    query: {
      userCompareField: 'USER_PAGE_ID';
      value: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/user-actions/find`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 권한이 없다면 Partner 생성하여 권한 부여
   *
   * @tags User
   * @name GrantPartner
   * @summary PARTNER 권한 부여
   * @request POST:/v1/user-actions/partner/grant
   */
  grantPartner = (params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/user-actions/partner/grant`,
      method: 'POST',
      ...params,
    });
  /**
   * @description 간편 로그인
   *
   * @tags User
   * @name SignOAuth
   * @summary 간편 로그인
   * @request POST:/v1/user-actions/sign/oauth
   */
  signOAuth = (data: OAuthRequestDto, params: RequestParams = {}) =>
    this.http.request<AuthWithClassicResponseDto, ErrorResponseDto>({
      path: `/v1/user-actions/sign/oauth`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Access Token 재발급
   *
   * @tags User
   * @name RenewAccessToken
   * @summary Access Token 재발급
   * @request POST:/v1/user-actions/token/renew
   */
  renewAccessToken = (params: RequestParams = {}) =>
    this.http.request<AccessTokenResponseDto, ErrorResponseDto>({
      path: `/v1/user-actions/token/renew`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name UpdateVerificationData
   * @summary 클래식 서버 본인인증 데이터 업데이트
   * @request POST:/v1/user-actions/update/verification
   */
  updateVerificationData = (
    data: VerificationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/user-actions/update/verification`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 휴대폰 본인인증
   *
   * @tags User
   * @name VerifyUserPhone
   * @summary 휴대폰 본인인증
   * @request POST:/v1/user-actions/verify/phone
   * @secure
   */
  verifyUserPhone = (
    data: VerifyUserPhoneRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/user-actions/verify/phone`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저 정보 조회
   *
   * @tags User
   * @name GetAllUser
   * @summary 전체 유저 기본 정보 조회
   * @request GET:/v1/users/
   */
  getAllUser = (
    query: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
      userPageId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoUserResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 테스트 유저 생성
   *
   * @tags User
   * @name CreateUser
   * @summary 테스트 유저 생성
   * @request POST:/v1/users/
   */
  createUser = (
    data: UserSignUpRequestDtoForTest,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저에 어드민 파트너 추가
   *
   * @tags User
   * @name AddAdminPartners
   * @summary 유저에 어드민 파트너 추가
   * @request POST:/v1/users/admin-partner
   * @secure
   */
  addAdminPartners = (
    data: UserAddAdminPartnerRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/admin-partner`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 현재 앱토스 지갑이 없는 유저의 앱토스 생성
   *
   * @tags User
   * @name CreateAptosWalletToUsers
   * @summary 유저 앱토스 지갑생성
   * @request POST:/v1/users/test/create/aptos
   * @secure
   */
  createAptosWalletToUsers = (
    data: DevUserAptosWalletCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<DevAptosCreateResponseDto, ErrorResponseDto>({
      path: `/v1/users/test/create/aptos`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저에 user 파트너 추가
   *
   * @tags User
   * @name AddUserPartners
   * @summary 유저에 user 파트너 추가
   * @request POST:/v1/users/user-partner
   * @secure
   */
  addUserPartners = (
    data: UserAddUserPartnerRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/user-partner`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저 탈퇴
   *
   * @tags User
   * @name DeleteUser
   * @summary 유저 탈퇴
   * @request DELETE:/v1/users/{userId}/
   * @secure
   */
  deleteUser = (userId: string, params: RequestParams = {}) =>
    this.http.request<SuccessCountResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 유저 정보 조회
   *
   * @tags User
   * @name GetUser
   * @summary 유저 기본 정보 조회
   * @request GET:/v1/users/{userId}/
   */
  getUser = (userId: string, params: RequestParams = {}) =>
    this.http.request<UserResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 유저 기본정보 수정
   *
   * @tags User
   * @name UpdateUser
   * @summary 유저 기본정보 수정
   * @request PATCH:/v1/users/{userId}/
   * @secure
   */
  updateUser = (
    userId: string,
    data: UserUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 계좌 삭제
   *
   * @tags User
   * @name DeleteBankAccount
   * @summary 계좌 삭제
   * @request DELETE:/v1/users/{userId}/bank-account
   * @secure
   */
  deleteBankAccount = (userId: string, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/bank-account`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 계좌 조회
   *
   * @tags User
   * @name GetBankAccount
   * @summary 계좌 조회
   * @request GET:/v1/users/{userId}/bank-account
   * @secure
   */
  getBankAccount = (userId: string, params: RequestParams = {}) =>
    this.http.request<BankAccountResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/bank-account`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * @description 계좌 재등록
   *
   * @tags User
   * @name UpdateBankAccount
   * @summary 계좌 재등록
   * @request PATCH:/v1/users/{userId}/bank-account
   * @secure
   */
  updateBankAccount = (
    userId: string,
    data: UserBankAccountRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/bank-account`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 계좌 등록
   *
   * @tags User
   * @name AddBankAccount
   * @summary 계좌 등록
   * @request POST:/v1/users/{userId}/bank-account
   * @secure
   */
  addBankAccount = (
    userId: string,
    data: UserBankAccountRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/bank-account`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 관리자 계정으로 계좌 승인/반려하기
   *
   * @tags User, Admin
   * @name UpdateBankAccountOpenStatusByAdmin
   * @summary 어드민으로 계좌 승인/반려
   * @request PATCH:/v1/users/{userId}/bank-account/admin
   * @secure
   */
  updateBankAccountOpenStatusByAdmin = (
    userId: string,
    query: {
      openStatus: 'PENDING' | 'COMPLETE' | 'REJECT';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/bank-account/admin`,
      method: 'PATCH',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저 컬렉션 목록
   *
   * @tags User
   * @name GetUserCollections
   * @summary 유저 컬렉션 목록
   * @request GET:/v1/users/{userId}/collections
   */
  getUserCollections = (
    userId: string,
    query: {
      collectionCategory:
        | 'ALL'
        | 'ART'
        | 'PHOTO'
        | 'PFP'
        | 'MEMBERSHIP'
        | 'NFTICON'
        | 'TICKET';
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoUserOwnCollectionsResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/collections`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description NFT 좋아요 목록 전체 조회
   *
   * @tags User
   * @name GetUserLikeNft
   * @summary NFT 좋아요 목록 전체 조회
   * @request GET:/v1/users/{userId}/liked-nfts
   * @secure
   */
  getUserLikeNft = (
    userId: string,
    query: {
      /** @uniqueItems true */
      blockChainTypeParams: (
        | 'AERGO'
        | 'ETHEREUM'
        | 'AVALANCHE'
        | 'POLYGON'
        | 'APTOS'
      )[];
      isForSaleParam: boolean;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** @uniqueItems true */
      nftUtilityTypeParams?: (
        | 'NFT_CONDITION_UTILITY'
        | 'NFTICON'
        | 'NFT_DOWNLOAD_UTILITY'
        | 'TICKET'
      )[];
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT' | 'PRICE';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoNftResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/liked-nfts`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 연동된 유저를 Offset Pagination으로 조회
   *
   * @tags User
   * @name FindLinkedUsers
   * @summary 연동된 유저 리스트 조회
   * @request GET:/v1/users/{userId}/linked-users
   * @secure
   */
  findLinkedUsers = (
    userId: string,
    query: {
      emailKeyword?: string;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'LINKDATE' | 'POINT' | 'VOTE';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoLinkedUserResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/linked-users`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 연동된 특정 유저를 조회
   *
   * @tags User
   * @name FindLinkedUser
   * @summary 연동된 특정 유저 조회
   * @request GET:/v1/users/{userId}/linked-users/{linkedUserId}
   * @secure
   */
  findLinkedUser = (
    userId: string,
    linkedUserId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<LinkedUserResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/linked-users/${linkedUserId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * @description 메타마스크 주소 조회
   *
   * @tags User
   * @name GetMetaMask
   * @summary 메타마스크 주소 조회
   * @request GET:/v1/users/{userId}/meta-masks
   */
  getMetaMask = (userId: string, params: RequestParams = {}) =>
    this.http.request<UserMetaMaskResponseDto[], ErrorResponseDto>({
      path: `/v1/users/${userId}/meta-masks`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 메타마스크 주소 추가
   *
   * @tags User
   * @name AddMetaMask
   * @summary 메타마스크 주소 추가
   * @request POST:/v1/users/{userId}/meta-masks/
   * @secure
   */
  addMetaMask = (
    userId: string,
    data: UserAddMetaMaskRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/meta-masks/`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 메타마스크 주소 삭제
   *
   * @tags User
   * @name DeleteMetaMask
   * @summary 메타마스크 주소 삭제
   * @request DELETE:/v1/users/{userId}/meta-masks/{metaMaskId}
   * @secure
   */
  deleteMetaMask = (
    userId: string,
    metaMaskId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/meta-masks/${metaMaskId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 메타마스크 주소 업데이트
   *
   * @tags User
   * @name UpdateMetaMask
   * @summary 메타마스크 주소 업데이트
   * @request PATCH:/v1/users/{userId}/meta-masks/{metaMaskId}
   * @secure
   */
  updateMetaMask = (
    userId: string,
    metaMaskId: string,
    data: UserUpdateMetaMaskRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/meta-masks/${metaMaskId}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저 수집한 NFT 조회
   *
   * @tags User
   * @name GetUserCollectNfts
   * @summary 유저 수집한 NFT 조회
   * @request GET:/v1/users/{userId}/nft/collects
   * @secure
   */
  getUserCollectNfts = (
    userId: string,
    query: {
      /** @uniqueItems true */
      blockChainTypeParams: (
        | 'AERGO'
        | 'ETHEREUM'
        | 'AVALANCHE'
        | 'POLYGON'
        | 'APTOS'
      )[];
      isForSaleParam: boolean;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** @uniqueItems true */
      nftUtilityTypeParams?: (
        | 'NFT_CONDITION_UTILITY'
        | 'NFTICON'
        | 'NFT_DOWNLOAD_UTILITY'
        | 'TICKET'
      )[];
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT' | 'PRICE';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoNftResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/nft/collects`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저 숨긴 NFT 조회
   *
   * @tags User
   * @name GetUserHideNfts
   * @summary 유저 숨긴 NFT 조회
   * @request GET:/v1/users/{userId}/nft/hides
   * @secure
   */
  getUserHideNfts = (
    userId: string,
    query: {
      /** @uniqueItems true */
      blockChainTypeParams: (
        | 'AERGO'
        | 'ETHEREUM'
        | 'AVALANCHE'
        | 'POLYGON'
        | 'APTOS'
      )[];
      isForSaleParam: boolean;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** @uniqueItems true */
      nftUtilityTypeParams?: (
        | 'NFT_CONDITION_UTILITY'
        | 'NFTICON'
        | 'NFT_DOWNLOAD_UTILITY'
        | 'TICKET'
      )[];
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT' | 'PRICE';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoNftResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/nft/hides`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저 발행한 NFT 조회
   *
   * @tags User
   * @name GetUserMintNfts
   * @summary 유저 발행한 NFT 조회
   * @request GET:/v1/users/{userId}/nft/mints
   * @secure
   */
  getUserMintNfts = (
    userId: string,
    query: {
      /** @uniqueItems true */
      blockChainTypeParams: (
        | 'AERGO'
        | 'ETHEREUM'
        | 'AVALANCHE'
        | 'POLYGON'
        | 'APTOS'
      )[];
      isForSaleParam: boolean;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** @uniqueItems true */
      nftUtilityTypeParams?: (
        | 'NFT_CONDITION_UTILITY'
        | 'NFTICON'
        | 'NFT_DOWNLOAD_UTILITY'
        | 'TICKET'
      )[];
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT' | 'PRICE';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoNftResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/nft/mints`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저 엔프티콘 NFT 조회
   *
   * @tags User
   * @name GetUserNfticonNfts
   * @summary 유저 엔프티콘 NFT 조회
   * @request GET:/v1/users/{userId}/nft/nfticons
   * @secure
   */
  getUserNfticonNfts = (
    userId: string,
    query: {
      isForSaleParam: boolean;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** @uniqueItems true */
      nfticonTypeParams?: (
        | 'RANDOM_NUMBER_QR'
        | 'RANDOM_NUMBER_BARCODE'
        | 'URL_QR'
        | 'URL'
      )[];
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT' | 'PRICE';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoNftResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/nft/nfticons`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Stripe에 고객 신용카드 정보 등록
   *
   * @tags User
   * @name RegisterCreditCard
   * @summary 신용카드 정보 등록
   * @request POST:/v1/users/{userId}/paymentIds
   * @secure
   */
  registerCreditCard = (
    userId: string,
    data: CreditCardDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SavedCardDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/paymentIds`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저의 등록된 Stripe 카드 식별자 삭제
   *
   * @tags User
   * @name DeleteCard
   * @summary Stripe 카드 삭제
   * @request DELETE:/v1/users/{userId}/paymentIds/stripeCardId
   * @secure
   */
  deleteCard = (userId: string, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/paymentIds/stripeCardId`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 유저 정보 조회
   *
   * @tags User
   * @name GetUserPrivacy
   * @summary 유저 상세 정보 조회
   * @request GET:/v1/users/{userId}/privacy
   * @secure
   */
  getUserPrivacy = (userId: string, params: RequestParams = {}) =>
    this.http.request<UserPrivacyResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/privacy`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * @description 유저 권한 리스트
   *
   * @tags User
   * @name GetRole
   * @summary 유저 권한 리스트
   * @request GET:/v1/users/{userId}/roles
   */
  getRole = (userId: string, params: RequestParams = {}) =>
    this.http.request<('ADMIN' | 'USER' | 'PARTNER')[], ErrorResponseDto>({
      path: `/v1/users/${userId}/roles`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 유저 권한 부여
   *
   * @tags User
   * @name CreateRole
   * @summary 유저 권한 부여
   * @request POST:/v1/users/{userId}/roles
   * @secure
   */
  createRole = (
    userId: string,
    data: SiteRoleRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/roles`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저 권한 삭제
   *
   * @tags User
   * @name DeleteRole
   * @summary 유저 권한 삭제
   * @request DELETE:/v1/users/{userId}/roles/{role}
   * @secure
   */
  deleteRole = (
    userId: string,
    role: 'ADMIN' | 'USER' | 'PARTNER',
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/roles/${role}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 정산 내역
   *
   * @tags User
   * @name GetSettlementHistories
   * @summary 정산 내역
   * @request GET:/v1/users/{userId}/settlement-histories
   * @secure
   */
  getSettlementHistories = (
    userId: string,
    query: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoUserSettlementHistoryResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/settlement-histories`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 정산 요청
   *
   * @tags User
   * @name SettlementRequest
   * @summary 정산 요청
   * @request POST:/v1/users/{userId}/settlement-request
   * @secure
   */
  settlementRequest = (userId: string, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/settlement-request`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * @description 유저 이용 정보
   *
   * @tags User
   * @name GetUserUsageInfo
   * @summary 유저 이용 정보
   * @request GET:/v1/users/{userId}/usages
   * @secure
   */
  getUserUsageInfo = (
    userId: string,
    query: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
      userUsageTypeParam: 'ALL' | 'MINT' | 'TRADE' | 'PRESENT' | 'DOWNLOAD';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoUserNftHistoryResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/usages`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 월렛 전체 목록
   *
   * @tags User
   * @name GetAllWalletList
   * @summary 월렛 전체 목록
   * @request GET:/v1/users/{userId}/wallets
   */
  getAllWalletList = (userId: string, params: RequestParams = {}) =>
    this.http.request<
      (
        | UserAergoBlockChainWalletResponseDto
        | UserAptosBlockChainWalletResponseDto
        | UserAvalancheBlockChainWalletResponseDto
        | UserEthereumBlockChainWalletResponseDto
        | UserPolygonBlockChainWalletResponseDto
      )[],
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/wallets`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 월렛 추가
   *
   * @tags User
   * @name AddWallet
   * @summary 월렛 추가
   * @request POST:/v1/users/{userId}/wallets
   * @secure
   */
  addWallet = (
    userId: string,
    data: WalletRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/wallets`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 월렛 삭제
   *
   * @tags User
   * @name DeleteWallet
   * @summary 월렛 삭제
   * @request DELETE:/v1/users/{userId}/wallets/{walletId}
   * @secure
   */
  deleteWallet = (
    userId: string,
    walletId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/wallets/${walletId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 월렛 조회
   *
   * @tags User
   * @name GetWalletList
   * @summary 월렛 조회
   * @request GET:/v1/users/{userId}/wallets/{walletId}
   */
  getWalletList = (
    userId: string,
    walletId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      | UserAergoBlockChainWalletResponseDto
      | UserAptosBlockChainWalletResponseDto
      | UserAvalancheBlockChainWalletResponseDto
      | UserEthereumBlockChainWalletResponseDto
      | UserPolygonBlockChainWalletResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/wallets/${walletId}`,
      method: 'GET',
      ...params,
    });
}
